import { Route, Switch } from 'react-router-dom';
import Assessment from './assessment/assessment/Assessment.component';
import Register from './assessment/register/Register.component';
import Answer from './assessment/answer/Answer.component';
import MyStore from './assessment/graphic/MyStore.component';
import OperationalIndicator from './operationalIndicator/OperationalIndicator.component';
import Information from './information/Information.component';

const Routes = () => {

  return (
    <Switch>
      <Route exact path="/loja/:id/" component={Information} />
      <Route exact path="/loja/:id/dashboard" component={MyStore} />
      <Route exact path="/loja/:id/avaliacao" component={Assessment} />
      {/* <Route exact path="/loja/:id/indicadores-operacionais" component={OperationalIndicator} /> */}
      {/*<Route exact path="/loja/:id/cadastrar-avaliacao" component={Register} />*/}
      <Route exact path="/loja/:id/avaliacao/responder/:idAssesment" component={Answer} />
      <Route component={() => <>NotFoundRedirect</>} />
    </Switch>
  );

}

export default Routes;
